import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { Appointments } from 'constants/resources';
import services from 'services';
import Loader from 'components/AntEnhancement/Loader';
import localeTranslator from 'library/Hocs/LocalTranslator';
import AppointmentInfo from './components/informations/AppointmentInfo';
import PatientInfo from './components/informations/PatientInfo';
import PackagesInfo from './components/informations/PackagesInfo';
import Header from './components/Header';
import PackagesDrawer from './components/drawers/PackagesDrawer';
import PatientLogDrawer from './components/drawers/PatientLogDrawer';
import UpdateAppointmentDrawer from './components/drawers/UpdateAppointmentDrawer';
import './style.css';
var ShowAppointment = function (_props) {
    var id = useParams().id;
    var location = useLocation();
    var navigate = useNavigate();
    var appointmentService = services.appointmentService, permissionService = services.permissionService;
    var _a = appointmentService.useGetAppointment(Number(id)), appointment = _a.data, isAppointmentLoading = _a.isLoading;
    var _b = useState(0), packagesDrawerKey = _b[0], setPackagesDrawerKey = _b[1];
    var _c = useState(false), showPackagesDrawer = _c[0], setShowPackagesDrawer = _c[1];
    var onClosePackagesDrawer = function () {
        setShowPackagesDrawer(false);
        setPackagesDrawerKey(function (key) { return key + 1; });
    };
    var _d = useState(0), patientLogDrawerKey = _d[0], setPatientLogDrawerKey = _d[1];
    var _e = useState(false), showPatientLogDrawer = _e[0], setShowPatientLogDrawer = _e[1];
    var _f = useState(false), showEditDrawer = _f[0], setShowEditDrawer = _f[1];
    var canEdit = Boolean(appointment === null || appointment === void 0 ? void 0 : appointment.getInEditableStatus()) &&
        permissionService.hasPermissionToEdit(Appointments);
    useEffect(function () {
        var _a;
        var openEdit = Boolean((_a = location.state) === null || _a === void 0 ? void 0 : _a.editAppointment);
        if (!canEdit || !openEdit)
            return;
        setShowEditDrawer(true);
        navigate(location.pathname, { replace: true, state: null });
    }, [canEdit, location.pathname, location.state, navigate]);
    var onClosePatientLogDrawer = function () {
        setShowPatientLogDrawer(false);
        setPatientLogDrawerKey(function (key) { return key + 1; });
    };
    return (_jsx(Loader, { renderSpinner: isAppointmentLoading, children: _jsx(_Fragment, { children: appointment && (_jsxs("div", { className: "appointment-show", children: [_jsx(Header, { appointment: appointment, onOpenPatientLog: function () { return setShowPatientLogDrawer(true); }, onEdit: function () { return setShowEditDrawer(true); } }), _jsxs("div", { className: "appointment-show__body", children: [_jsx(AppointmentInfo, { appointment: appointment }), _jsx(PatientInfo, { appointment: appointment }), _jsx(PackagesInfo, { appointment: appointment, reservationPackages: [], reservationsTransactions: [], setShowPackagesDrawer: setShowPackagesDrawer })] }), _jsx(PackagesDrawer, { visiable: showPackagesDrawer, patient: appointment.getPatient(), appointment: appointment, onCloseDrawer: onClosePackagesDrawer }, "Packages-".concat(packagesDrawerKey)), canEdit && (_jsx(UpdateAppointmentDrawer, { visiable: showEditDrawer, appointment: appointment, onCloseDrawer: function () { return setShowEditDrawer(false); } })), permissionService.hasPatientLogPermission() && (_jsx(PatientLogDrawer, { visiable: showPatientLogDrawer, onCloseDrawer: onClosePatientLogDrawer, appointment: appointment }, "patientLog-".concat(patientLogDrawerKey)))] })) }) }));
};
export default localeTranslator(ShowAppointment, 'showVisit');
